import script from "./ProductImage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductImage.vue?vue&type=script&setup=true&lang=js"

import "./ProductImage.vue?vue&type=style&index=0&id=9786e448&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9786e448"]])

export default __exports__